import axios from 'axios';
import history from './history';
import { processLogout } from './AuthService';

/**
 * @component
 * Wrapper of `axios`, when receiving 401 response, will redirect to login page
 */

const errorHandling = (error, showError) => {
    if (!axios.isCancel(error) && showError) {
        if (error.response && error.response.status === 401) {
            processLogout();
            history.replace('/login');
        }
        else if (error.response && error.response.status === 403) {
            history.replace('/AccessDeclined');
        }
        else {
            if (!error.response || error.response.status !== 404) {
                console.error(error, error.response);
            }
        }
    }
    return Promise.reject(error);
};

class Ajax {
    defaults = axios.defaults;
    CancelToken = axios.CancelToken;

    get(url, responseType = 'json', cancelToken = null, headers = null, showError = true) {
        let config = { responseType: responseType, cancelToken: cancelToken };
        if (headers !== null && headers !== undefined) {
            config.headers = headers;
        }

        config.headers = Object.assign({}, config.headers, { 'Mr-Token': 'CAE983C3-7320-46C8-9F58-6C87DBF66EE9' });
        
        return axios.get(url, config, config)
            .then(res => {
                return Promise.resolve(res);
            })
            .catch(error => {
                return errorHandling(error, showError);
            });
    }

    post(url, data, responseType = 'json', cancelToken = null, headers = null) {
        let config = { responseType: responseType, cancelToken: cancelToken };
        if (headers !== null && headers !== undefined) config.headers = Object.assign({}, config.headers, headers);

        config.headers = Object.assign({}, config.headers, { 'Mr-Token': 'CAE983C3-7320-46C8-9F58-6C87DBF66EE9' });

        return axios.post(url, data, config)
            .then(res => {
                return Promise.resolve(res);
            })
            .catch(error => {
                return errorHandling(error);
            });
    }

    put(url, data, responseType = 'json') {
        let config = {
            responseType: responseType,
            headers: {
                'Mr-Token': 'CAE983C3-7320-46C8-9F58-6C87DBF66EE9'
            }
        };
        return axios.put(url, data, config)
            .then(res => {
                return Promise.resolve(res);
            })
            .catch(error => {
                return errorHandling(error);
            });
    }

    delete(url) {
        let config = {
            headers: {
                'Mr-Token': 'CAE983C3-7320-46C8-9F58-6C87DBF66EE9'
            }
        };
        return axios.delete(url, config)
            .then(res => {
                return Promise.resolve(res);
            })
            .catch(error => {
                return errorHandling(error);
            });
    }

    all(promises) {
        let config = {
            headers: {
                'Mr-Token': 'CAE983C3-7320-46C8-9F58-6C87DBF66EE9'
            }
        };
        return axios.all(promises, config);
    }

    spread(callbacks) {
        let config = {
            headers: {
                'Mr-Token': 'CAE983C3-7320-46C8-9F58-6C87DBF66EE9'
            }
        };
        return axios.spread(callbacks, config);
    }

    isCancel = (value) => {
        let config = {
            headers: {
                'Mr-Token': 'CAE983C3-7320-46C8-9F58-6C87DBF66EE9'
            }
        };

        return axios.isCancel(value, config);
    }
}

export default new Ajax();